<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="name" >
        <span slot="label" >
          <a-tooltip>
            {{$t('仓库名称')}}<template slot="title">{{$t('仓库名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('仓库名称')" />
      </a-form-model-item>

        <a-form-item :label="$t('ERP仓库')" prop="erpWarehouseId">
          <a-select :placeholder="$t('通用.输入.请选择')+$t('ERP仓库')"
                    v-model="form.erpWarehouseId" style="width: 100%" allow-clear :disabled="formType==2">
            <a-select-option v-for="(d, index) in this.erpWarehouse" :key="index" :value="d.id">{{ d.name }}</a-select-option>
          </a-select>
        </a-form-item>
      <a-row>
        <a-col :span="2">
          {{'  '}}
        </a-col>
      <a-col :span="2">
       {{'请选择地址：'}}
      </a-col>
        <a-col :span="2">
        <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"  style="width: 30%">
          <MappModel ref="MappModel" @ok="tencentMapOk"></MappModel>
        </a-form-model-item>
        </a-col>
      </a-row>

      <a-form-model-item prop="address" >
        <span slot="label" >
          <a-tooltip>
            {{$t('地址')}}<template slot="title">{{$t('地址')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.address" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="areap" >
        <span slot="label" >
          <a-tooltip>
            {{$t('省')}}<template slot="title">{{$t('省')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.areap" disabled="true"/>
      </a-form-model-item>
      <a-form-model-item prop="areac" >
        <span slot="label" >
          <a-tooltip>
            {{$t('市')}}<template slot="title">{{$t('市')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.areac" disabled="true"/>
      </a-form-model-item>

      <a-form-model-item prop="mobile" >
        <span slot="label" >
          <a-tooltip>
            {{$t('仓库管理人手机号')}}<template slot="title">{{$t('仓库管理人手机号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.mobile" :maxLength="30" :placeholder="$t('通用.输入.请输入')+$t('仓库管理人手机号')"  :disabled="formType==2"/>
      </a-form-model-item>


      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('备注')" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getWarehouse,
  addWarehouse,
  updateWarehouse,
  getWarehouseLise,
  getWarehouseList
} from '@/api/warehouse/warehouse'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import MappModel from './MappModel.vue';
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    MappModel
  },
  data () {
    return {
      erpWarehouse:[],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        areap: null,

        areac: null,

        mobile: null,
        erpWarehouseId: null,

        remark: null,
        address: null,
        lon: null,
        lat: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          {required: true, message: this.$t('仓库名称') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        address: [
          {required: true, message: this.$t('地址') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: this.$t('手机号') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        erpWarehouseId: [
          {required: true, message:'请选择erp仓库', trigger: 'blur'}
        ],

      }
    }
  },
  filters: {
  },
  created () {
    this.getWarehouseList();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    tencentMapOk(record) {
      console.log(11111111111,record)
      this.form.lon = record.lng;
      this.form.lat = record.lat;
      this.form.address = record.address;
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        areap: null,
        areac: null,
        mobile: null,
        erpWarehouseId: null,
        lat: null,
        lon: null,
        remark: null,
        address: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    getWarehouseList() {
      getWarehouseList().then(response => {
        this.erpWarehouse = response.data;
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWarehouse({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateWarehouse(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addWarehouse(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
